import React, { useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { getAccount } from "../../../graphql/account/account-queries";

import { Grid, MenuItem, TextField as TextFieldMui } from "@material-ui/core";

import {
  CheckboxGroupInput,
  Create,
  email,
  FormDataConsumer,
  maxLength,
  minLength,
  RadioButtonGroupInput,
  regex,
  required,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
  useNotify,
} from "react-admin";
import { useForm } from "react-final-form";

import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { getUserTypeAcls, logError } from "../../../utils/appUtils";
import { REGEX_PHONE, TrueOrFalse, UserType } from "../../../utils/constants";
import { CustomerCreateHelp } from "./CustomerHelp";
import { ValidateCreateButton } from "./ValidateCreateButton";
import { AccountDropDown } from "../../../components/common/AccountDropDown";

const validateRequired = required();
const validateEmail = [required(), email()];
const validatePhone = [
  regex(REGEX_PHONE, "Must be valid Phone No."),
  minLength(10),
  maxLength(20),
];

const handleAccountChange = async (
  value,
  form,
  setContacts,
  setAccount,
  notify,
) => {
  const accountId = value?.id;
  if (accountId) {
    try {
      debugger;
      const response = await API.graphql(
        graphqlOperation(getAccount, { id: accountId }),
      );
      // ignore a response for an account the user has since changed away from
      if (form.getState().values.accountId !== accountId) return;
      const account = response.data.getAccount;
      setContacts(account.contacts);
      setAccount(account);
    } catch (err) {
      logError("managerApp:CustomerCreate:handleAccountChange", err, notify);
    }
  }
};

const ContactList = ({ form, contacts }) => {
  const [selectedContact, setSelectedContact] = useState({ id: "", name: "" });

  const handleContactChange = (event) => {
    debugger;
    const value = event.target.value;
    setSelectedContact(value);

    if (value?.name) {
      const [firstName, ...rest] = value.name.split(" ");
      const lastName = rest.pop(); // Extracts the last name
      form.change("firstName", firstName);
      form.change("lastName", lastName);
      form.change("email", value.email);
      form.change("phone", value.phone);
    } else {
      form.change("firstName", "");
      form.change("lastName", "");
      form.change("email", "");
      form.change("phone", "");
    }
  };

  if (contacts?.length > 0)
    return (
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12} md={6}>
          <TextFieldMui
            select
            label="Contacts"
            margin="dense"
            variant="outlined"
            fullWidth
            value={selectedContact}
            onChange={handleContactChange}
            helperText={" "}
          >
            {[
              <MenuItem key="" value="">
                <span>​Select a contact...</span>
              </MenuItem>,
              ...contacts.map((itm) => (
                <MenuItem key={itm.email} value={itm}>
                  {itm.name}
                </MenuItem>
              )),
            ]}
          </TextFieldMui>
        </Grid>
      </Grid>
    );
  return null;
};

const UserCreateForm = ({ setAccount, notify, ...props }) => {
  const form = useForm();
  const aclList = getUserTypeAcls(UserType.CUSTOMER);
  const [contacts, setContacts] = useState([]);

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <Grid container spacing={6}>
          <Grid item xs={12} md={8}>
            <Grid container direction="column" spacing={1}>
              <Grid container direction="row" spacing={2}>
                {window.appUser.type !== UserType.CUSTOMER && (
                  <Grid item xs={12} lg={6}>
                    <AccountDropDown
                      source="accountId"
                      label="Account"
                      onAccountChange={(value) =>
                        handleAccountChange(
                          value,
                          form,
                          setContacts,
                          setAccount,
                          notify,
                        )
                      }
                      validate={validateRequired}
                      allowEmpty={false}
                    />
                  </Grid>
                )}
                <Grid item xs={12} md={6}>
                  <RadioButtonGroupInput
                    source="sendInviteEmail"
                    label="Send Invite Email"
                    choices={TrueOrFalse}
                    defaultValue={true}
                    helperText={false}
                    style={{ marginTop: 0 }}
                  />
                </Grid>
              </Grid>
              <ContactList form={form} contacts={contacts} />
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextInput
                    source="firstName"
                    label="First Name"
                    validate={validateRequired}
                    variant="outlined"
                    fullWidth
                    helperText={false}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextInput
                    source="lastName"
                    label="Last Name"
                    validate={validateRequired}
                    variant="outlined"
                    fullWidth
                    helperText={false}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextInput
                    source="email"
                    type="email"
                    parse={(v) => (v !== "" ? v.toLowerCase() : undefined)}
                    validate={validateEmail}
                    variant="outlined"
                    fullWidth
                    helperText={false}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextInput
                    source="phone"
                    type="tel"
                    validate={validatePhone}
                    variant="outlined"
                    fullWidth
                    helperText={false}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextInput
                    source="description"
                    label="Description"
                    variant="outlined"
                    fullWidth
                    helperText={false}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid container direction="column" spacing={1}>
              <Grid container direction="row" spacing={1}>
                {aclList?.length > 0 && (
                  <Grid item xs={12}>
                    <CheckboxGroupInput
                      source="acl"
                      label="Access Permissions"
                      row={false}
                      fullWidth
                      choices={aclList}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </FormDataConsumer>
  );
};

const UserCreateActions = (props) => (
  <TopToolbar>
    <HelpButton>
      <CustomerCreateHelp {...props} />
    </HelpButton>
    <BackButton {...props} />
  </TopToolbar>
);

const UserCreateToolbar = ({ account, ...props }) => (
  <Toolbar {...props}>
    <ValidateCreateButton account={account} />
  </Toolbar>
);

export const CustomerCreate = (props) => {
  const notify = useNotify();
  const [account, setAccount] = useState();

  return (
    <Create
      {...props}
      title={<ForceTitle title="New User" />}
      actions={<UserCreateActions />}
    >
      <SimpleForm
        variant="outlined"
        submitOnEnter={false}
        toolbar={<UserCreateToolbar account={account} />}
      >
        <UserCreateForm {...props} setAccount={setAccount} notify={notify} />
      </SimpleForm>
    </Create>
  );
};
